import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ArrowUpRight, Play, Mic, FileText, Award } from 'lucide-react';
import Navigation from '../components/home/Navigation';
import Footer from '../components/home/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const mediaItems = [
  // ERANIA BRACKETT
  {
    person: 'Erania Brackett',
    firm: 'Brackett Partners',
    type: 'video',
    title: 'Strategic Intelligence for Leaders',
    source: 'XRaised',
    description: 'How growth-stage B2B companies can leverage strategic intelligence to drive growth and make data-driven decisions. Brackett discusses predictive intelligence, brand strategy, and customer experience design.',
    url: 'https://xraised.com/videos/strategic-intelligence-for-leaders/',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
    imagePosition: 'center 20%',
  },
  {
    person: 'Erania Brackett',
    firm: 'Brackett Partners',
    type: 'podcast',
    title: 'Strategic Intelligence for Leaders',
    source: 'XRaised Podcast (Spotify)',
    description: 'Erania shares insights on strategic advisory services and how intelligence-driven approaches outperform traditional consulting. Available on Spotify and Amazon Music.',
    url: 'https://open.spotify.com/episode/3qa0kMWxuT834SaWFBlFsl',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
    imagePosition: 'center 20%',
  },
  {
    person: 'Erania Brackett',
    firm: 'Brackett Partners',
    type: 'video',
    title: 'DS World 2023: On Customer Experience, ESG, and Leadership',
    source: 'Oral Health Group',
    description: '"I\'ve always known that I needed a broad, comprehensive skill set. Career progression is a second job. Just doing great work is not going to get you there." Brackett on her journey from GE to CMO at Dentsply Sirona.',
    url: 'https://www.oralhealthgroup.com/industry-spotlight/ds-world-interview-with-erania-brackett-andrea-frohning-of-dentsply-sirona/',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
    imagePosition: 'center 20%',
  },
  {
    person: 'Erania Brackett',
    firm: 'Brackett Partners',
    type: 'article',
    title: 'Leadership in Digital Dentistry Is a Key Pillar of Our Business Strategy',
    source: 'Dental Tribune',
    description: 'Brackett on digital transformation, sustainability leadership, and why companies that wait a year to innovate will find the market in a completely different place.',
    url: 'https://www.dental-tribune.com/c/dentsply-sirona/news/leadership-in-digital-dentistry-is-a-key-pillar-of-our-business-strategy/',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
    imagePosition: 'center 20%',
  },
  {
    person: 'Erania Brackett',
    firm: 'Brackett Partners',
    type: 'article',
    title: 'Women Leaders Discuss Empowering the Female Workforce',
    source: 'Dimensions of Dental Hygiene',
    description: 'Brackett on the role of women in corporate leadership, building inclusive teams, and creating pathways for the next generation of female executives.',
    url: 'https://dimensionsofdentalhygiene.com/dentsply-sironas-women-leaders-discuss-the-companys-goal-to-empower-the-female-workforce/',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
    imagePosition: 'center 20%',
  },
  {
    person: 'Erania Brackett',
    firm: 'Brackett Partners',
    type: 'press',
    title: 'Savoy Magazine: Most Influential Black Executives in Corporate America',
    source: 'Dentistry Today / Savoy Magazine',
    description: 'Erania Brackett recognized in Savoy Magazine\'s 2022 list of the Most Influential Black Executives in Corporate America for her leadership at Dentsply Sirona.',
    url: 'https://www.dentistrytoday.com/dentsply-sirona-executive-management-members-erania-brackett-and-cheree-johnson-recognized-in-savoy-magazines-2022-most-influential-black-executives-in-corporate-america/',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
    imagePosition: 'center 20%',
  },
  {
    person: 'Erania Brackett',
    firm: 'Brackett Partners',
    type: 'press',
    title: 'Knowles Corporation Appoints Erania Brackett to Board of Directors',
    source: 'Knowles Investor Relations',
    description: 'Appointed to the board of Knowles Corporation (NYSE: KN), bringing P&L leadership across global marketing, customer experience, and ESG from GE Healthcare, Medtronic, and Dentsply Sirona.',
    url: 'https://investor.knowles.com/news/news-details/2023/Knowles-Appoints-Erania-Brackett-to-its-Board-of-Directors/default.aspx',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
    imagePosition: 'center 20%',
  },
  {
    person: 'Erania Brackett',
    firm: 'Brackett Partners',
    type: 'press',
    title: 'Appointed Chief Marketing Officer of Dentsply Sirona',
    source: 'Dentsply Sirona',
    description: 'Brackett joined Dentsply Sirona as SVP and CMO to elevate and unify the brand post-acquisition. She later expanded to lead customer experience, ESG, and the global orthodontic aligners business.',
    url: 'https://www.dentsplysirona.com/en-us/company/news-and-press-release-detail-page.html/content/dam/master/news/en/corporate-news/2021/erania-brackett-appointed-chief-marketing-officer-of-dentsply-si',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
    imagePosition: 'center 20%',
  },
  // FOREST T. HARPER JR.
  {
    person: 'Forest T. Harper Jr.',
    firm: 'Harper Cook Consulting',
    type: 'video',
    title: 'Breakthrough Mentoring',
    source: 'Vimeo',
    description: 'Forest T. Harper Jr. on why the leaders who matter most are the ones who make other leaders. A conversation about mentoring, communication, and the discipline of influence.',
    url: 'https://vimeo.com/1210251665',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/nhsnrfz3_Forest%20%283%20of%203%29.JPG',
    imagePosition: 'center 15%',
  },
  {
    person: 'Forest T. Harper Jr.',
    firm: 'Harper Cook Consulting',
    type: 'video',
    title: 'The CodeBreaker Mindset: Forest Harper, INROADS President & CEO',
    source: 'YouTube',
    description: 'Harper discusses leadership principles, breaking barriers, and building pathways for the next generation of corporate leaders.',
    url: 'https://www.youtube.com/watch?v=gL4jY3SFSDw',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/nhsnrfz3_Forest%20%283%20of%203%29.JPG',
    imagePosition: 'center 15%',
  },
  {
    person: 'Forest T. Harper Jr.',
    firm: 'Harper Cook Consulting',
    type: 'video',
    title: 'How INROADS Is Shaping Future CEOs',
    source: 'Rolling Out / YouTube',
    description: 'Forest Harper explains how INROADS creates career pathways and shapes future leaders through opportunity, mentorship, and corporate partnership.',
    url: 'https://www.youtube.com/watch?v=nx47cU9S8vw',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/nhsnrfz3_Forest%20%283%20of%203%29.JPG',
    imagePosition: 'center 15%',
  },
  {
    person: 'Forest T. Harper Jr.',
    firm: 'Harper Cook Consulting',
    type: 'article',
    title: 'INROADS CEO Forest Harper Jr. Leads Young People from the Classroom to the Board Room',
    source: 'Alabama News Center',
    description: '"After I had been vice president for a while, I woke up one morning and looked in the mirror and said, there\'s nothing I can do about being the first African American in this role, but there\'s something I can do about being the only one."',
    url: 'https://alabamanewscenter.com/2020/02/20/inroads-ceo-forest-harper-jr-leads-young-people-from-the-classroom-to-the-board-room/',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/nhsnrfz3_Forest%20%283%20of%203%29.JPG',
    imagePosition: 'center 15%',
  },
  {
    person: 'Forest T. Harper Jr.',
    firm: 'Harper Cook Consulting',
    type: 'video',
    title: '#OpenUpTheWorkforce Executive Series',
    source: 'Symba / YouTube',
    description: 'Forest Harper discusses his 28 years at Pfizer, leading INROADS, and how organizations can open up career pathways for underrepresented talent.',
    url: 'https://www.youtube.com/watch?v=8G-EUccZDXs',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/nhsnrfz3_Forest%20%283%20of%203%29.JPG',
    imagePosition: 'center 15%',
  },
  {
    person: 'Forest T. Harper Jr.',
    firm: 'Harper Cook Consulting',
    type: 'press',
    title: "Marquis Who's Who Honors Forest T. Harper Jr.",
    source: '24-7 Press Release',
    description: 'Forest T. Harper Jr. recognized for expertise in over 40 years of nonprofit and business leadership, including 28 years at Pfizer and CEO of INROADS.',
    url: 'https://www.24-7pressrelease.com/press-release/529245/marquis-whos-who-honors-forest-t-harper-jr-for-expertise-in-over-40-years-of-nonprofit-and-business-leadership-thriving-sustainable-impact',
    image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/nhsnrfz3_Forest%20%283%20of%203%29.JPG',
    imagePosition: 'center 15%',
  },
  // DR. R. SUKUMAR
  {
    person: 'Dr. R. Sukumar',
    firm: 'OSG Analytics',
    type: 'article',
    title: 'Founder Profile: R. Sukumar',
    source: 'Keystone Edge',
    description: '"I wanted to leave a legacy and develop a strong discipline around a fact-based approach to helping our clients grow their business." Features ASEMAP methodology and OSG\'s 250% three-year growth.',
    url: 'https://keystoneedge.com/2015/12/31/founder-profile-r-sukumar/',
    image: `${API}/resources/newsletter-img-5.jpg`,
  },
  {
    person: 'Dr. R. Sukumar',
    firm: 'OSG Analytics',
    type: 'article',
    title: 'Working from Home and the Growth of OSG Analytics',
    source: 'OSG Analytics',
    description: 'A conversation with CEO Dr. R. Sukumar about OSG\'s growth trajectory, the ASEMAP methodology, and building a global analytics practice from the ground up.',
    url: 'https://osganalytics.com/blog/working-from-home-and-growth-of-osg-analytics-a-talk-with-our-ceo/',
    image: `${API}/resources/newsletter-img-5.jpg`,
  },
  {
    person: 'Dr. R. Sukumar',
    firm: 'OSG Analytics',
    type: 'press',
    title: 'Featured Speaker: Emerging Markets USA 2012',
    source: 'Business Wire',
    description: 'Dr. Sukumar presented "Emerging Markets Launch Excellence" on achieving pharmaceutical product launch success across global markets.',
    url: 'https://www.businesswire.com/news/home/20121009005453/en/Dr.-R.-Sukumar-Optimal-Strategix-Group-CEO-Featured-Speaker-at-Emerging-Markets-USA-2012',
    image: `${API}/resources/newsletter-img-5.jpg`,
  },
  {
    person: 'Dr. R. Sukumar',
    firm: 'OSG Analytics',
    type: 'press',
    title: 'Bennett CXO Series with Dr. R. Sukumar',
    source: 'Bennett University',
    description: 'Dr. Sukumar featured in Bennett University\'s CXO Series, discussing customer analytics, behavioral science, and the future of data-driven decision-making.',
    url: 'https://www.bennett.edu.in/bennett-life/life-at-campus/events/bennett-cxo-series-with-osgs-dr-r-sukumar/',
    image: `${API}/resources/newsletter-img-5.jpg`,
  },
  {
    person: 'Dr. R. Sukumar',
    firm: 'OSG Analytics',
    type: 'article',
    title: 'Optimal Strategix Group: Pharmaceutical Industry Profile',
    source: 'Pharma Tech Outlook',
    description: 'Industry profile covering OSG\'s ASEMAP methodology, customer journey analytics, and predictive intelligence capabilities for pharmaceutical and healthcare organizations.',
    url: 'https://www.pharmatechoutlook.com/optimal-strategix-group',
    image: `${API}/resources/newsletter-img-5.jpg`,
  },
];

const typeIcons = {
  video: Play,
  podcast: Mic,
  article: FileText,
  press: Award,
};

const typeLabels = {
  video: 'Video',
  podcast: 'Podcast',
  article: 'Article',
  press: 'Press',
};

export default function MediaPage() {
  const [filter, setFilter] = React.useState('all');

  const people = ['all', 'Erania Brackett', 'Forest T. Harper Jr.', 'Dr. R. Sukumar'];
  const filtered = filter === 'all' ? mediaItems : mediaItems.filter(m => m.person === filter);

  return (
    <div className="min-h-screen bg-white" data-testid="media-page">
      <Helmet>
        <title>Media & Press | APIG Alliance</title>
        <meta name="description" content="Interviews, keynotes, articles, and press coverage featuring the APIG Alliance partners: Erania Brackett, Forest T. Harper Jr., and Dr. R. Sukumar." />
        <link rel="canonical" href="https://predictiveintelligencegrowthalliance.com/media" />
      </Helmet>

      <Navigation />

      {/* Header */}
      <section className="pt-32 pb-12 bg-white">
        <div className="container-luxury">
          <div className="max-w-3xl mx-auto text-center">
            <p className="overline mb-4">Media & Press</p>
            <h1 className="heading-display text-4xl sm:text-5xl text-[#0B1A2B] mb-6" data-testid="media-headline">
              Conversations, Coverage, and Keynotes
            </h1>
            <p className="body-large">
              Interviews, articles, and speaking engagements from the APIG Alliance partners.
            </p>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="pb-8 bg-white">
        <div className="container-luxury">
          <div className="flex flex-wrap justify-center gap-3" data-testid="media-filters">
            {people.map(p => (
              <button
                key={p}
                onClick={() => setFilter(p)}
                className={`px-5 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  filter === p
                    ? 'bg-[#0B1A2B] text-white'
                    : 'bg-[#F8FAFC] text-[#475569] border border-[#E2E8F0] hover:border-[#D97706] hover:text-[#D97706]'
                }`}
                data-testid={`filter-${p.replace(/\s/g, '-').toLowerCase()}`}
              >
                {p === 'all' ? 'All Partners' : p}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Media Grid */}
      <section className="pb-24 bg-white">
        <div className="container-luxury">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((item, i) => {
              const Icon = typeIcons[item.type] || FileText;
              return (
                <a
                  key={i}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block border border-[#E2E8F0] hover:border-[#D97706]/40 hover:shadow-lg transition-all duration-500"
                  data-testid={`media-card-${i}`}
                >
                  <div className="h-48 overflow-hidden bg-[#0B1A2B] relative">
                    <img
                      src={item.image}
                      alt={item.person}
                      className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
                      style={item.imagePosition ? { objectPosition: item.imagePosition } : {}}
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-[#0B1A2B]/80 px-2.5 py-1">
                      <Icon className="w-3 h-3 text-[#D97706]" />
                      <span className="text-[10px] font-medium text-white uppercase tracking-wider">{typeLabels[item.type]}</span>
                    </div>
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs font-medium text-[#D97706]">{item.person}</span>
                      <span className="text-[#CBD5E1]">·</span>
                      <span className="text-xs text-[#94A3B8]">{item.source}</span>
                    </div>
                    <h3 className="font-serif text-lg text-[#0B1A2B] leading-snug mb-2 group-hover:text-[#D97706] transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-sm text-[#475569] leading-relaxed line-clamp-3">
                      {item.description}
                    </p>
                    <span className="inline-flex items-center gap-1 text-xs font-medium text-[#0B1A2B] group-hover:text-[#D97706] mt-3 transition-colors">
                      View <ArrowUpRight className="w-3 h-3" />
                    </span>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
